import _asyncToGenerator from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data: function data() {
    return {
      buttons: [{
        label: '更新redis中用户角色关系',
        url: '/platform/user/userRolesRules',
        loading: false,
        disabled: false
      }, {
        label: '更新redis中角色权限关系',
        url: '/platform/role/rolePermInfo',
        loading: false,
        disabled: false
      }, {
        label: '更新redis中权限资源关系',
        url: '/platform/perm/permRolesRules',
        loading: false,
        disabled: false
      }]
    };
  },
  methods: {
    handleClick: function handleClick(button) {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                button.loading = true;
                _context.prev = 1;
                _context.next = 4;
                return _this.$API.putRequest({
                  url: button.url
                });
              case 4:
                res = _context.sent;
                if (!(res.code !== '0000000000')) {
                  _context.next = 7;
                  break;
                }
                throw new Error(res.message);
              case 7:
                _this.$message.success(res.message);
                button.disabled = true;
                _context.next = 14;
                break;
              case 11:
                _context.prev = 11;
                _context.t0 = _context["catch"](1);
                _this.$message.error(_context.t0.message);
              case 14:
                _context.prev = 14;
                button.loading = false;
                return _context.finish(14);
              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[1, 11, 14, 17]]);
      }))();
    }
  }
};